export default class NativeHeaderbarRevealer {
  constructor(options = {}) {
    this.data = {
      propTargets: ['--headerbar-height-extension'],
      states: {
        extended: '80px',
        retracted: '70px',
        smallScreen: '50px' // Added state for screens < 575px
      },
      lastScrollY: 0,
    };
  }

  init() {
    window.addEventListener(
      'scroll',
      () => {
        this.updateHeaderbarRevealClass();
        this.lastScrollY = window.scrollY;
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      () => {
        this.updateHeaderbarRevealClass();
      },
      { passive: true }
    );
  }

  updateHeaderbarRevealClass() {
    const windowWidth = window.innerWidth;
    const state =
      windowWidth > 1200
        ? window.scrollY > this.lastScrollY
          ? this.data.states.retracted
          : this.data.states.extended
        : windowWidth < 575
          ? this.data.states.smallScreen // Apply small screen state for < 575px
          : this.data.states.extended;

    for (const propTarget of this.data.propTargets) {
      document.documentElement.style.setProperty(propTarget, state);
    }

    const siteHeaderWrapper = document.querySelector('.site-header-wrapper');
    const siteLogo = document.querySelector('.site-logo');

    if (state === this.data.states.retracted) {
      siteHeaderWrapper.classList.add('scrolled');
      siteLogo.querySelector('img').src = '/ui/main/img/family_pharmacy_logo_2.png';
    } else {
      siteHeaderWrapper.classList.remove('scrolled');
      siteLogo.querySelector('img').src = '/ui/main/img/family_pharmacy_logo.png';
    }
  }
}
